'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class; // Lib


// Actions


// Selectors


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _lodash = require('lodash');

var _socketActions = require('../socket/socketActions');

var _socketChannelSelector = require('./socketChannelSelector');

var _socketChannelSelector2 = _interopRequireDefault(_socketChannelSelector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        dispatchChannelsUpdated: function dispatchChannelsUpdated(channelUpdate) {
            return dispatch((0, _socketActions.channelsUpdated)(channelUpdate));
        }
    };
};

var SocketChannelManager = (_dec = (0, _reactRedux.connect)(_socketChannelSelector2.default, mapDispatchToProps), _dec(_class = function (_React$Component) {
    _inherits(SocketChannelManager, _React$Component);

    function SocketChannelManager() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, SocketChannelManager);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SocketChannelManager.__proto__ || Object.getPrototypeOf(SocketChannelManager)).call.apply(_ref, [this].concat(args))), _this), _this.updateChannels = function (_ref2) {
            var nextChannels = _ref2.nextChannels,
                _ref2$prevChannels = _ref2.prevChannels,
                prevChannels = _ref2$prevChannels === undefined ? [] : _ref2$prevChannels,
                boardChannels = _ref2.boardChannels;
            var dispatchChannelsUpdated = _this.props.dispatchChannelsUpdated;


            var joined = (0, _lodash.difference)(nextChannels, prevChannels);
            var left = (0, _lodash.difference)(prevChannels, nextChannels);

            // Don't update if we haven't joined or left anything
            if (!joined.length && !left.length) return;

            dispatchChannelsUpdated({
                joined: joined,
                left: left,
                boardChannels: boardChannels
            });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(SocketChannelManager, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _props = this.props,
                channels = _props.channels,
                boardChannels = _props.boardChannels;

            this.updateChannels({ nextChannels: channels, boardChannels: boardChannels });
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var channels = nextProps.channels,
                boardChannels = nextProps.boardChannels;


            if (channels !== this.props.channels) {
                this.updateChannels({ nextChannels: channels, prevChannels: this.props.channels, boardChannels: boardChannels });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.Children.only(this.props.children);
        }
    }]);

    return SocketChannelManager;
}(_react2.default.Component)) || _class);


SocketChannelManager.propTypes = {
    children: _propTypes2.default.element.isRequired,
    channels: _propTypes2.default.array,
    boardChannels: _propTypes2.default.array,
    dispatchChannelsUpdated: _propTypes2.default.func
};

exports.default = SocketChannelManager;


//////////////////
// WEBPACK FOOTER
// ./src/client/utils/collaboration/SocketChannelManager.js
// module id = 2117
// module chunks = 0